module.exports = __webpack_public_path__ + "static/media/personality.a264e910.svg";